import React, { Component } from "react";
import PageHelmet from "../../component/common/Helmet";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import FooterTwo from "../../component/footer/FooterTwo";

interface Props {}

class Go4rit extends Component<Props>{
    render(): React.ReactNode{
        return(
            <React.Fragment>
                
                <PageHelmet pageTitle='Project Details' />

                <Header headertransparent="header--transparent" colorblack="color--white" logoname="logo.png" />

                <div className="rn-page-title-area pt--120 pb--190" style={{ backgroundImage: `url("/assets/images/banner-bg.jpg")` }}  >
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-color ">GO4Rit</h2>
                                    <p>eCommerce</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        <div className="row sercice-details-content pb--80">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4rit/1.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <h4 className="title">Go4Rit</h4>
                                                    <p>As part of a team, I helped develop GO4Rit, an eCommerce app connecting merchants with consumers to sell leftover food at discounted prices. Key features include:</p>
                                                    <p><strong>Sustainability Focus:</strong> Reduces food waste by promoting affordable surplus food sales.</p>
                                                    <p><strong>Frontend:</strong> Vue.js and Capacitor for a seamless, cross-platform experience.</p>
                                                    <p><strong>Backend:</strong> Laravel for secure user accounts, food listings, and merchant management.</p>
                                                    <p><strong>GIS Integration:</strong> Google Maps API to locate nearby merchants with available offerings.</p>
                                                    <p><strong>Real-Time Inventory:</strong> Live updates on food availability with automatic quantity adjustments as purchases are made.</p>
                                                    <p><strong>Push Notifications:</strong> Alerts users when new surplus items become available from nearby merchants.</p>
                                                    <p><strong>Rating &amp; Review System:</strong> Buyers can rate sellers to build trust and quality within the community.</p>
                                                    <p>This project showcases my ability to build impactful, scalable, and user-friendly solutions that address real-world challenges.</p>
                                                    <h4 className="title">My Working Process</h4>
                                                    <ul className="liststyle">
                                                        <li>Collaborating with stakeholders to define user flows and merchant onboarding requirements</li>
                                                        <li>Building responsive Vue.js components with Capacitor for cross-platform mobile deployment</li>
                                                        <li>Designing the Laravel backend architecture with RESTful APIs for listings, orders, and user management</li>
                                                        <li>Integrating Google Maps API for real-time geolocation and proximity-based merchant discovery</li>
                                                        <li>Implementing push notification infrastructure for real-time inventory alerts</li>
                                                        <li>Writing unit and integration tests across frontend and backend services</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <h2 className="text-center mb--50">Project Screenshots</h2>

                                        <div className="row sercice-details-content align-items-center">
                                        <div className="col-lg-4 col-12 order-1 order-lg-2">
                                        <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4rit/2.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-12 order-1 order-lg-2">
                                            <div className="thumb">
                                                    <img className="w-100" src="/assets/images/works/go4rit/3.png" alt="Service Images"/>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                
                <FooterTwo />
            </React.Fragment>
        )
    }
}
export default Go4rit;
